import { Linkedin } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-[#051024] border-t border-[#233554] py-12" data-testid="site-footer">
      <div className="px-6 md:px-12 lg:px-24 flex flex-col md:flex-row gap-6 items-start md:items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="w-10 h-10 border border-[#D4AF37] flex items-center justify-center">
            <span className="font-serif text-[#D4AF37]">PD</span>
          </div>
          <div>
            <p className="font-serif text-[#F8F9FA]">Project DeliverEdge Consulting</p>
            <p className="text-[10px] uppercase tracking-[0.25em] text-[#A8B2D1]">Deepshikha Jaiswal · PMP</p>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-x-8 gap-y-3 text-sm text-[#A8B2D1]">
          <a href="#about" className="hover:text-[#D4AF37] transition-colors">About</a>
          <a href="#services" className="hover:text-[#D4AF37] transition-colors">Services</a>
          <a href="#results" className="hover:text-[#D4AF37] transition-colors">Impact</a>
          <a href="#contact" className="hover:text-[#D4AF37] transition-colors">Contact</a>
        </div>

        <a
          href="https://www.linkedin.com/in/shikhajaiswal-pmp/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-[#A8B2D1] hover:text-[#D4AF37] transition-colors"
          data-testid="footer-linkedin"
        >
          <Linkedin size={16} />
          <span className="text-sm">LinkedIn</span>
        </a>
      </div>
      <div className="px-6 md:px-12 lg:px-24 mt-10 pt-6 border-t border-[#233554] text-center md:text-left">
        <p className="text-xs text-[#A8B2D1]/70">
          © {new Date().getFullYear()} Project DeliverEdge Consulting · Deepshikha Jaiswal. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
